import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Form, 
  Button, 
  Card, 
  Spinner 
} from 'react-bootstrap';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell
} from 'recharts';
import axios from '../api/axios';
import PropTypes from 'prop-types';

const RevenueKPI = ({ outlets = [], loadingOutlets = false }) => {
  const token = localStorage.getItem('authToken');
  
  // State for filters
  const [filters, setFilters] = useState({
    outlet: "",
    timeRange: 'weekly',
    classType: ""
  });

  // State for revenue data
  const [revenueData, setRevenueData] = useState({
    total: {},
    filtered: {},
    avgSales: []
  });

  // Loading states
  const [loading, setLoading] = useState({
    total: true,
    filtered: false
  });

  // Colors for charts
  const pieColors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  // Fetch revenue data (works for both total and filtered)
  const fetchRevenueData = async (isFiltered = false) => {
    console.log("In In ");
    
    try {
      setLoading(prev => ({ ...prev, [isFiltered ? 'filtered' : 'total']: true }));
      
      // const params = isFiltered 
      // ? {
      //     weekly: filters.timeRange === "weekly",
      //     monthly: filters.timeRange === "monthly",
      //     ...(filters.classType !== "" && { classType: filters.classType }),
      //     outletId: filters.outlet || undefined
      //   }
      // : {};

      const params = {
          weekly: filters.timeRange === "weekly",
          monthly: filters.timeRange === "monthly",
          ...(filters.classType !== "" && { classType: filters.classType }),
          outletId: filters.outlet || undefined
      }

        console.log("In In Params :", params);

      // const response = await axios.get('dashboard/getRevenueStat', {
      const response = await axios.get('dashboard/getRevenueStatThroughSummary', {      
        headers: { Authorization: `Bearer ${token}` },
        params
      });
        console.log("Response of revenue statss :", response?.data?.data?.data[0]);

        if (filters.classType === 'FOOD' || 'BEVERAGE') {
          console.log("Class Type INside If :", filters.classType);
          
          const dataKey = isFiltered ? 'filtered' : 'total';
          setRevenueData(prev => ({
            ...prev,
            [dataKey]: response?.data?.data?.data[0] || {},
            avgSales: response?.data?.data?.data[0]?.avgSales || []
          }));
        } else {
          console.log("Hello");
          
          const dataKey = isFiltered ? 'filtered' : 'total';
          setRevenueData(prev => ({
            ...prev,
            // [dataKey]: response.data.data.data.revenueData || {},
            // avgSales: response.data.data.data.avgSales || []
            [dataKey]: response?.data?.data?.data[0] || {},
          }));
        }

      // if (response?.data?.data) {

      //   const dataKey = isFiltered ? 'filtered' : 'total';
      //   setRevenueData(prev => ({
      //     ...prev,
      //     // [dataKey]: response.data.data.data.revenueData || {},
      //     // avgSales: response.data.data.data.avgSales || []
      //     [dataKey]: response?.data?.data?.revenueStats || {},
      //   }));
      // }
    } catch (error) {
      console.error('Error fetching revenue data:', error);
    } finally {
      setLoading(prev => ({ ...prev, [isFiltered ? 'filtered' : 'total']: false }));
    }
  };

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  // Apply filters
  const applyFilters = () => {
    fetchRevenueData(true);
  };

  // Reset filters
  const resetFilters = () => {
    setFilters({
      outlet: "",
      timeRange: 'weekly',
      classType: "FOOD"
    });
    fetchRevenueData(false);
  };

  // Initial data fetch
  useEffect(() => {
    fetchRevenueData(false);
  }, []);

  // Fetch filtered data when filters change
  useEffect(() => {
    const hasFilters = filters.outlet || filters.classType !== "BOTH" || filters.timeRange !== "weekly";
    // const hasFilters = filters.outlet || filters.classType !== "FOOD" || filters.timeRange !== "weekly";
    if (hasFilters) {
      console.log("Hello");
      
      fetchRevenueData(true);
    }
  }, [filters.outlet, filters.timeRange, filters.classType]);

  // Prepare data for revenue breakdown charts
  const getRevenueBreakdownData = (data) => {
    if (!data || Object.keys(data).length === 0) return [];
    
    return [
      { name: 'Total Revenue', value: data.totalGrandTotal || 0 },
      { name: 'Taxable Amount', value: data.totalTaxale || 0 },
      { name: 'Tax Amount', value: data.totalTaxAmount || 0 },
      { name: 'Discount', value: data.totalDiscount || 0 }
    ];
  };  

  // Determine which data to display

  const hasFilters = filters.outlet || filters.classType !== "" || filters.timeRange !== "weekly";
  console.log("HAS FILTERS 1 :", hasFilters);
  
  const currentRevenueData = hasFilters ? revenueData.filtered : revenueData.total;

  console.log("Current Revenue Data :", currentRevenueData);
  
  const revenueBreakdownData = getRevenueBreakdownData(currentRevenueData);
  const avgSalesData = revenueData.avgSales || [];

  return (
    <Container fluid className="py-4 shadow-sm bg-white">
      <h2 className="mb-4 fw-bold">REVENUE ANALYSIS</h2>
      <hr />
      
      {/* Summary Cards */}
      <Row className="g-4 mb-4">
        {['totalGrandTotal', 'totalTaxale', 'totalTaxAmount', 'totalDiscount'].map((key, index) => {
          const titles = {
            totalGrandTotal: 'Total Revenue',
            totalTaxale: 'Taxable Amount',
            totalTaxAmount: 'Tax Amount',
            totalDiscount: 'Discount'
          };          
          const icons = {
            totalGrandTotal: 'bi-cash-coin',
            totalTaxale: 'bi-receipt',
            totalTaxAmount: 'bi-percent',
            totalDiscount: 'bi-tag'
          };
          const colors = {
            totalGrandTotal: '#007bff',
            totalTaxale: '#28a745',
            totalTaxAmount: '#dc3545',
            totalDiscount: '#fd7e14'
          };

          return (
            <Col md={3} key={key}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body className="p-3">
                  <div className="d-flex align-items-center mb-2">
                    <i className={`bi ${icons[key]} fs-4 me-2`} style={{ color: colors[key] }}></i>
                    <Card.Title className="text-muted mb-0" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                      {titles[key]}
                    </Card.Title>
                  </div>
                  {loading.total || (hasFilters && loading.filtered) ? (
                    <div className="text-center py-2">
                      <Spinner animation="border" size="sm" style={{ color: colors[key] }} />
                    </div>
                  ) : (
                    <Card.Text className="fw-semibold fs-4" style={{ color: colors[key] }}>
                      {/* {currentRevenueData[key] !== undefined ? `₹${currentRevenueData[key]?.toFixed(2)}` : 'N/A'} */}
                      {typeof currentRevenueData[key] === 'number'
                      ? `₹${currentRevenueData[key].toFixed(2)}`
                      : 'N/A'}
                    </Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* Filter Controls */}
      <Row className="mb-4 g-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Outlet</Form.Label>
            <Form.Select 
              value={filters.outlet}
              onChange={(e) => handleFilterChange('outlet', e.target.value)}
              disabled={loadingOutlets}
            >
              <option value="">All Outlets</option>
              {outlets.map(outlet => (
                <option key={outlet._id} value={outlet._id}>
                  {outlet.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        
        <Col md={2}>
          <Form.Group>
            <Form.Label>Duration</Form.Label>
            <Form.Select
              value={filters.timeRange}
              onChange={(e) => handleFilterChange('timeRange', e.target.value)}
            >
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </Form.Select>
          </Form.Group>
        </Col>
        
        <Col md={2}>
          <Form.Group>
            <Form.Label>Class Type</Form.Label>
            <Form.Select
              value={filters.classType}
              onChange={(e) => handleFilterChange('classType', e.target.value)}
            >
              <option value="">Both</option>
              <option value="FOOD">Food</option>
              <option value="BEVERAGE">Beverage</option>
            </Form.Select>
          </Form.Group>
        </Col>
        
        <Col md={2} className="d-flex align-items-end">
          <Button 
            variant="primary" 
            onClick={applyFilters} 
            disabled={loading.filtered}
            className="w-100"
          >
            {loading.filtered ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Loading...
              </>
            ) : 'Apply Filters'}
          </Button>
        </Col>
        
        <Col md={2} className="d-flex align-items-end">
          <Button 
            variant="outline-secondary" 
            onClick={resetFilters}
            className="w-100"
          >
            Reset
          </Button>
        </Col>
      </Row>

      {/* Charts Section */}
      {(loading.total || (hasFilters && loading.filtered)) ? (
        <Row className="mb-4">
          <Col className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading revenue data...</p>
          </Col>
        </Row>
      ) : (
        <>
          {/* Revenue Breakdown Pie Chart */}
          <Row className="mb-4">
            <Col md={12}>
              <h4>Revenue Breakdown</h4>
              {revenueBreakdownData.length > 0 ? (
                <div style={{ height: '400px' }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Tooltip 
                        formatter={(value) => [`₹${value.toLocaleString()}`, 'Amount']} 
                      />
                      <Legend 
                        layout="horizontal" 
                        verticalAlign="bottom" 
                        align="center"
                      />
                      <Pie
                        data={revenueBreakdownData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={120}
                        innerRadius={40}
                        label={({ name, value }) => {
                          const total = revenueBreakdownData.reduce((sum, item) => sum + item.value, 0);
                          const percent = total ? (value / total) * 100 : 0;
                          return `${name}: ₹${value.toFixed(2)} (${percent.toFixed(1)}%)`;
                        }}
                        labelLine={false}
                        paddingAngle={2}
                      >
                        {revenueBreakdownData.map((entry, index) => (
                          <Cell 
                            key={`cell-${index}`} 
                            fill={pieColors[index % pieColors.length]} 
                            stroke="#fff"
                            strokeWidth={1}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center bg-light rounded" style={{ height: '200px' }}>
                  <p className="text-muted">No revenue data available</p>
                </div>
              )}
            </Col>
          </Row>

          {/* Average Sales Bar Chart */}
          {avgSalesData.length > 0 && (
            <Row className="mb-4">
              <Col md={12}>
                <h4>Average Sales</h4>
                <div style={{ height: '400px' }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={avgSalesData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis 
                        dataKey="_id" 
                        angle={-45} 
                        textAnchor="end"
                        height={60}
                      />
                      <YAxis />
                      <Tooltip formatter={(value) => [`₹${value.toFixed(2)}`, 'Amount']} />
                      <Legend />
                      <Bar 
                        dataKey="avgSale" 
                        fill="#82ca9d" 
                        name="Average Sale"
                        radius={[4, 4, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Col>
            </Row>
          )}
        </>
      )}
    </Container>
  );
};

RevenueKPI.propTypes = {
  outlets: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string
    })
  ),
  loadingOutlets: PropTypes.bool
};

RevenueKPI.defaultProps = {
  outlets: [],
  loadingOutlets: false
};

export default RevenueKPI;